import axiosInstance from '@/utils/axiosInstance';
import { getAuthHeaders } from '../../../utils/api';
import { API_ENDPOINTS, buildUrl } from '@/constant/constant';
import { API_URL, USER_ROLES } from '../../../constant/constant';

// Vendor API functions
export const vendorApi = {
  // Update vendor profile/settings
  updateVendor: async (vendorData) => {
    try {
      const response = await axiosInstance.put(
        `${API_URL.BASE_VENDOR}/rest/big-local/api/v1/vendor?X-Vendor-Id=${vendorData?.id}`,
        vendorData,
        {
          headers: {
            sessionToken: localStorage.getItem('sessionToken'),
            'X-USER-ROLE': USER_ROLES.VENDOR,
          },
        }
      );
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error updating vendor:', error);
      return { success: false, error: error.message };
    }
  },

  // Update vendor status (Approved/OutOfStation)
  updateVendorStatus: async (vendorId, status) => {
    try {
      const response = await axiosInstance.put(
        `${API_URL.BASE_VENDOR}/rest/big-local/api/v1/vendor/status?vendorId=${vendorId}&status=${status}`,
        {},
        {
          headers: {
            ...getAuthHeaders(),
            'X-USER-ROLE': USER_ROLES.VENDOR,
          },
        }
      );
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error updating vendor status:', error);
      return { success: false, error: error.message };
    }
  },

  // Fetch categories
  fetchCategories: async () => {
    try {
      const response = await axiosInstance.get(buildUrl(API_ENDPOINTS.CATEGORIES), {
        headers: getAuthHeaders(),
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching categories:', error);
      return { success: false, error: error.message };
    }
  },
};

// Helper functions for data preparation
export const prepareVendorUpdateData = (user, updates = {}) => {
  return {
    id: user?.id,
    name: updates.name || user?.name,
    shopName: user?.shopName,
    emailId: updates.emailId || user?.emailId,
    alternateContact: updates.alternateContact || user?.alternateContact,
    deliveryRadius: user?.deliveryRadius * 1000,
    viewOnly: user?.viewOnly,
    storeFront: user?.storeFront,
  };
};

export const prepareCategoryIds = (categories) => {
  return categories.reduce((acc, curr) => {
    if (curr.id) acc.push(curr.id);
    if (Array.isArray(curr.subCategories)) {
      for (const sub of curr.subCategories) {
        if (sub.id) acc.push(sub.id);
      }
    }
    return acc;
  }, []);
};
